import React from 'react';

import cls from 'classnames';

import './styles.css';

export const DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right',
};

export default props => {
  return (
    <div
      className={cls('Banner', props.className, {
        [`Banner--${props.direction}`]: true,
      })}
      style={props.style}
    >
      <div
        className={cls('Banner__bg', {
          [`Banner__bg--${props.direction}`]: true,
        })}
      />
      <div
        className={cls('Banner__content', {
          [`Banner__content--${props.direction}`]: true,
          'Banner__content--noPaddings': props.noPaddings,
        })}
      >
        {!!props.title && <div className="Banner__title">{props.title}</div>}
        {props.children}
      </div>
    </div>
  );
};
